import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { composeUrl } from 'app/core/shared/helper/url.helper';
import { BehaviorSubject, Observable, take } from 'rxjs';
import { Response } from 'app/modules/management-of-change/model';

@Injectable({ providedIn: 'root' })
export class MOCDashboardService {
    private _MOCFieldSummary: BehaviorSubject<any> = new BehaviorSubject(null);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    get mocFieldSummary$(): Observable<any> {
        return this._MOCFieldSummary.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    getMocFieldSummary(params: any): Observable<any> {
        const url = composeUrl(
            '/v1/WIM/DashboardWIM/moc/fields/dashboard',
            params
        );

        let response = this._httpClient.get<Response<any>>(url).pipe(take(1));

        response.subscribe((res) => {
            this._MOCFieldSummary.next(res);
        });

        return response;
    }

    getMocStringSummary(params: any): Observable<any> {
        const url = composeUrl(
            '/v1/WIM/DashboardWIM/moc/strings/dashboard',
            params
        );

        return this._httpClient.get<any>(url);
    }

    getMocFieldSummaryExport(): Observable<Blob> {
        const url = composeUrl(`v1/WIM/DashboardWim/moc/fields/summary/export`);
        return this._httpClient
            .get<Blob>(url, { responseType: 'blob' as 'json', params: { PageSize: 9999 } })
            .pipe(take(1));
    }

    getMocStringSummaryExport(): Observable<Blob> {
        const url = composeUrl(`v1/WIM/DashboardWim/moc/strings/summary/export`);
        return this._httpClient
            .get<Blob>(url, { responseType: 'blob' as 'json', params: { PageSize: 9999 } })
            .pipe(take(1));
    }
}
